import template from './BotConnectView.html';
import ApplicationModalView from './ApplicationModal/ApplicationModalView.html';
import ApplicationModalController from './ApplicationModal/ApplicationModalController';
import { v4 as uuid } from 'uuid';
export const ACCOUNT_EXTERNAL_ID = 'AccountExternalId';
export const BUSINESS_OWNER = 'postmaster@businesschat.gw.msging.net';
class BotConnectController {
    static $inject = ['ApplicationService2', 'ModalService', 'BotClientService', 'BLIP_DOMAIN_URL'];
    constructor(ApplicationService2, ModalService, BotClientService, BLIP_DOMAIN_URL) {
        this.ApplicationService2 = ApplicationService2;
        this.ModalService = ModalService;
        this.BotClientService = BotClientService;
        this.BLIP_DOMAIN_URL = BLIP_DOMAIN_URL;
        this.loading = false;
        this.searchBots = async () => {
            try {
                this.loading = true;
                this.applications = await this.ApplicationService2.getApplications(this.tenantId);
            }
            catch (error) {
                console.error(error);
            }
            finally {
                this.loading = false;
            }
        };
        this.handleChangeTenant = (event) => {
            this.tenantId = event.target.value;
        };
    }
    async setConfigurations(app, config) {
        const instance = await this.BotClientService.customBuild(app);
        await instance.connect();
        await instance.sendCommand({
            id: uuid(),
            method: 'set',
            uri: `lime://${BUSINESS_OWNER}/configuration`,
            type: 'application/json',
            resource: config,
        });
        instance.close();
    }
    async connectAccount({ shortName }) {
        try {
            const app = await this.ApplicationService2.getApplication(shortName);
            await this.setConfigurations(app, {
                [ACCOUNT_EXTERNAL_ID]: this.businessId,
            });
            this.redirectURL = `${this.BLIP_DOMAIN_URL}application/detail/${shortName}/home`;
            this.isConnected = true;
        }
        catch (error) {
            console.error(error);
        }
    }
    async openModal(application) {
        const modal = await this.ModalService.showModal({
            template: ApplicationModalView,
            controller: ApplicationModalController,
            controllerAs: '$ctrl',
            inputs: {
                application,
            },
        });
        const app = await modal.close;
        app && this.connectAccount(app);
    }
}
BotConnectController.$inject = ['ApplicationService2', 'ModalService', 'BotClientService', 'BLIP_DOMAIN_URL'];
export const BotConnectComponent = {
    controller: BotConnectController,
    controllerAs: '$ctrl',
    template,
    bindings: {
        businessId: '<',
    },
};
